export default __webpack_public_path__ + "static/media/noun_Share_896160.fb9432af.svg";